'use client';

import { Trans, t } from '@lingui/macro';
import { Box, Container, Stack, Typography } from '@mui/material';
import { AppPalettes, PageHeader } from '@prismo-io/design-system';
import Image from 'next/image';
import type { FC } from 'react';
import DefaultHelioLogo from '@/assets/aura/app/primary/common/icone-helio.svg';
import backgroundImg from '@/assets/helio/backgrounds/no-result.png';
import helioImg from '@/assets/helio/no-result.png';
import { ThemeProvider } from '@prismo-io/design-system/theme-provider';
import type { ResponseValueSchemaT } from '../../utils/fetch-user-result-locked';
import { Countdown } from '../count-down';
type Props = {
  result: NonNullable<ResponseValueSchemaT>;
};
export const HelioBlockedResult: FC<Props> = props => {
  const {
    result
  } = props;
  const helioTitle = <>
      <Typography color="white" fontSize={{
      none: '1.10rem',
      sm: '1.25rem',
      md: '1.75rem'
    }} fontWeight="bolder">
        Helio
      </Typography>
      <Typography color="white" fontSize={{
      none: '1.10rem',
      sm: '1.25rem',
      md: '1.75rem'
    }}>
        |
      </Typography>
      <Typography color="white" fontSize={{
      none: '1.10rem',
      sm: '1.25rem',
      md: '1.75rem'
    }}>
        {t`Motivations`}
      </Typography>
    </>;
  return <ThemeProvider theme={AppPalettes.light} options={{
    key: 'helio-blocked-result'
  }} data-sentry-element="ThemeProvider" data-sentry-component="HelioBlockedResult" data-sentry-source-file="index.tsx">
      <Box position="relative" width="100%" height="100vh" component="section" overflow="hidden" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Box component="div" position="absolute" top="0" bottom="0" right="0" left="0" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Image src={backgroundImg} alt="" style={{
          objectFit: 'cover',
          objectPosition: 'center'
        }} fill data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        </Box>
        <PageHeader pageImg={DefaultHelioLogo} pageTitleRender={helioTitle} data-sentry-element="PageHeader" data-sentry-source-file="index.tsx" />
        <Box component="div" height="100%" py={{
        none: '1.5rem',
        sm: '2rem',
        lg: '4rem',
        xl: '6rem'
      }} overflow="auto" data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Container maxWidth="md" data-sentry-element="Container" data-sentry-source-file="index.tsx">
            <Stack position="relative" direction="column" alignItems="center" spacing={4} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
              <Box component="div" position="relative" width="100%" height={{
              none: '10rem',
              sm: '15rem'
            }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
                <Image src={helioImg} alt="" style={{
                objectFit: 'contain',
                objectPosition: 'center'
              }} fill data-sentry-element="Image" data-sentry-source-file="index.tsx" />
              </Box>
              <Typography variant="h2" fontSize="1.5rem" lineHeight="2rem" textAlign="center" color="primary.main" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
                <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Vous avez déjà passé Helio</Trans>
              </Typography>
              <Typography fontSize="1.5rem" color="white" textAlign="center" lineHeight="2rem" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
                {result.unlocked_at instanceof Date ? <Countdown endDate={result.unlocked_at} /> : <Trans>
                    Résultats en attente de déblocage par votre administrateur.
                    Ce dernier bénéficie d'un accès direct à vos résultats et
                    peut choisir quand les débloquer, afin de vous assurer une
                    restitution optimale.
                  </Trans>}
              </Typography>
            </Stack>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>;
};